import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MapService } from '../../shared/services/map.service';
import { IWGSharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  @Input() data;
  @Input() Isoa2;
  @Input() selectedIsoa2;

  isEmbed = false;

 constructor(private map: MapService, private sharedService: IWGSharedService) { }

  ngOnInit(): void {
      this.map.buildMap();
      this.isEmbed = this.sharedService.getIsEmbed();
  }
  ngOnChanges(changes: SimpleChanges){

    if ('data' in changes) {       
        this.map.setData(this.data);
        this.map.setFitIsoA2(this.selectedIsoa2);
    }    
  }
}